import {defineComponent, reactive} from "@vue/composition-api";
import {onInputDialogue, onAlertDialogue, onConfirmDialogue} from "@/functions/system-modal-functions";

enum ModalType {

    input,

    alert,

    confirm
}

export enum ModalIconType {

    none,

    info,

    warning,

    error,

    success,

    question
}

export default defineComponent({

    setup() {

        const defaultValidation = (input: string) => input?.trim().length > 0;

        const model = reactive({
            showModal: false,
            title: '',
            input: '',
            inputType: 'text' as 'text' | 'password',
            placeholder: '',
            message: '',
            warning: '',
            type: ModalType.input,
            validate: defaultValidation,
            icon: ModalIconType.none});

        let inputCallback: ((name: string) => void) | undefined;

        let alertCallback: (() => void) | undefined;

        let confirmCallback: (() => void) | undefined;

        let cancelCallback: (() => void) | undefined;

        onInputDialogue(args => {

            alertCallback = undefined;

            confirmCallback = undefined;

            inputCallback = args.confirmCallback;

            cancelCallback = args.cancelCallback;

            model.input = args.initialInputData || '';
            model.inputType = args.inputType ?? 'text';

            model.placeholder = args.placeholder || '';

            model.message = args.message;

            model.warning = args.warning ?? '';

            model.title = args.title;

            model.type = ModalType.input;

            model.icon = args.icon ?? ModalIconType.none;

            model.validate = args.validation || defaultValidation;

            model.showModal = true;
        });

        onAlertDialogue(args => {

            confirmCallback = undefined;

            inputCallback = undefined;

            cancelCallback = undefined;

            model.input = '';
            model.inputType = 'text';

            alertCallback = args.confirmCallback;

            model.message = args.message;

            model.title = args.title;

            model.type = ModalType.alert;

            model.icon = args.icon ?? ModalIconType.none;

            model.showModal = true;
        });

        onConfirmDialogue(args => {

            alertCallback = undefined;

            inputCallback = undefined;

            model.input = '';
            model.inputType = 'text';

            confirmCallback = args.confirmCallback;

            cancelCallback = args.cancelCallback;

            model.message = args.message;

            model.title = args.title;

            model.type = ModalType.confirm;

            model.icon = args.icon ?? ModalIconType.none;

            model.showModal = true;
        });

        const clearCompletionState = () => {

            inputCallback = undefined;

            alertCallback = undefined;

            confirmCallback = undefined;

            cancelCallback = undefined;

            model.input = '';

            model.inputType = 'text';
        };

        const cancel = () => {

            model.showModal = false;

            const callback = cancelCallback;

            clearCompletionState();

            if (typeof (callback) === 'function'){

                callback();
            }
        };

        const confirm = () => {

            model.showModal = false;

            const input = model.input;

            const selectedInputCallback = inputCallback;

            const selectedAlertCallback = alertCallback;

            const selectedConfirmCallback = confirmCallback;

            clearCompletionState();

            if (typeof (selectedInputCallback) === 'function'){

                selectedInputCallback(input);

            } else if (typeof (selectedAlertCallback) === 'function'){

                selectedAlertCallback();

            } else if (typeof (selectedConfirmCallback) === 'function'){

                selectedConfirmCallback();
            }
        };

        return {

            model,

            cancel,

            confirm,

            ModalType,

            ModalIconType
        };
    }
});
